import { Component, Input, OnInit } from '@angular/core';
import { OeAppPersonService } from '../oe-app-person.service';
import { GamificationBadgeDto } from '../types/GamificationBadgeDto';
import { Language } from '../types/language';
import { BadgeDescriptionService } from './badge-description.service';

@Component({
  selector: 'lp2-badge-description',
  templateUrl: './badge-description.component.html',
  styleUrls: ['./badge-description.component.scss'],
})
export class BadgeDescriptionComponent implements OnInit {
  @Input() badge: GamificationBadgeDto;
  loading = false;
  description: string;
  descriptionTranslation: string;
  isTranslationActive = false;
  showTranslationButton = false;

  constructor(
    private oeAppPersonService: OeAppPersonService,
    private badgeDescriptionService: BadgeDescriptionService
  ) {}

  ngOnInit() {
    this.loadDescription();
  }

  toggleTranslation() {
    this.isTranslationActive = !this.isTranslationActive;
  }

  loadDescription() {
    const preferredLang = this.oeAppPersonService.preferredLang as Language;
    this.loading = true;
    this.badgeDescriptionService
      .fetchDescription(this.badge, preferredLang)
      .subscribe(
        ([description, translation]) => {
          this.description = description;
          this.descriptionTranslation = translation;
          this.loading = false;
          this.showTranslationButton =
            preferredLang !== this.badgeDescriptionService.defaultLanguage &&
            !!this.descriptionTranslation;
        },
        () => {
          this.loading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/badge-description/badge-description.component.ts